(function($) {
  
$('.logo-slider').slick({
  infinite: true,
  slidesToShow: 7,
  slidesToScroll: 1,
  arrows: true,
  autoplay: true,
  autoplaySpeed: 1500,
  responsive: [
   {
     breakpoint: 1024,
     settings: {
       slidesToShow: 4,
       slidesToScroll: 1,
       arrows: false,
       infinite: true
     }
   }, 
   {
     breakpoint: 640,
     settings: {
       slidesToShow: 2,
       slidesToScroll: 1,
       arrows: false,
       infinite: true
     }
   }
  ]
});

})(jQuery);